 function sizeSorting(sizes) {
   
    let temp = ['S' , 'M' , 'L' , 'XL' , 'XXL' , '3XL' , '4XL', '30', '32', '34','36','38','40','42','44',       ];
    
     return sizes.sort((a,b)=> {
       if(temp.indexOf(b['key']) === -1) return 1
       if(temp.indexOf(a['key']) === -1) return 1
       if(temp.indexOf(b['key']) > temp.indexOf(a['key']) ) return -1
       else return 0
     })
}

window.isFirstAttachEventToWizzyFilter = true;

window.onWizzyScriptLoaded = function () {
  
  const replaceTemplate=(div)=>{
  let newDiv = document.getElementById(div+"-new").text;
  let oldDiv = document.getElementById(div)
  oldDiv.text = newDiv;
  }
    
  replaceTemplate("wizzy-search-results-product");
  replaceTemplate("wizzy-search-results");
  replaceTemplate("wizzy-search-wrapper");
  replaceTemplate("wizzy-autocomplete-topproducts");
  replaceTemplate("wizzy-autocomplete-suggestions");
  replaceTemplate("wizzy-common-select");
  replaceTemplate("wizzy-facet-item-common");
  replaceTemplate("wizzy-selected-facet-item-common");
  replaceTemplate("wizzy-progress");
  replaceTemplate("wizzy-facet-block");
  replaceTemplate("wizzy-popup-modal");


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_LAZY_INIT, function(payload){
     // console.log(payload," <== BEFORE_LAZY_INIT");

    const searchBarWizz = document.getElementById('Search-In-Modal');

        
        function toggleAutocompleteClass() {
            const body = document.body;
            if (document.activeElement === searchBarWizz) {

              setTimeout(function(){
                 new Swiper('.autocomplete-top-products .collection-cardSwiper', {
                  slidesPerView: 1,
                  spaceBetween: 5,
                  loop: false,
                  autoplay:false,
                  breakpoints: {
                    768: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                  },
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                  },
                });
                if(window.ReloadSmartWishlist) window.ReloadSmartWishlist();
              },100);


              ///////////////////////////////////////////////////

              setTimeout(function(){
                const cloneButtons = document.querySelectorAll(".cloneBtn");        
                cloneButtons.forEach((button) => {
                  const productHandle = button.getAttribute("product-handle");
                  const WizzyCartDiv = document.querySelector(".innervariant");
                
                  const domId = button.getAttribute("id") + "-inner";
                  let divId = "wizzy-product-" + button.getAttribute("id");
                
                  const productInfoDiv = button.closest(".new_card_product_info");
                
                  const yyDiv = productInfoDiv.querySelector(".yy");
                  const collectionColorSwatches = productInfoDiv.querySelector(".collection-color-swacthes");
                
                  if (productHandle) {
                    const newurl = `${window.location.origin}/products/${productHandle}?view=atbproductdata`;
                
                    // Using XMLHttpRequest instead of fetch
                    const xhr = new XMLHttpRequest();
                    xhr.open("GET", newurl, true);
                    
                    xhr.onload = function () {
                      if (xhr.status === 200) {
                        // console.log("ATB PRODUCT DATA...");
                        
                        var newDiv = document.createElement('div');
                        newDiv.innerHTML = xhr.responseText;
                        
                        if (document.getElementById(`${divId}`)) {
                          document.getElementById(`${divId}`).appendChild(newDiv);
                        }
                      } else {
                        console.error('Network response was not ok');
                      }
                    };
                
                    xhr.onerror = function () {
                      console.error("Wizzy Error Fetching ATB Product Data using XMLHttpRequest");
                    };
                
                    xhr.send();
                  }
                
                  /*
                  const swatchURL = `${window.location.origin}/products/${productHandle}?view=wizzyColorSwatches`;
                  const xhrSwatches = new XMLHttpRequest();
                  xhrSwatches.open("GET", swatchURL, true);
                  xhrSwatches.onload = function () {
                    if (xhrSwatches.status === 200) {
                      collectionColorSwatches.innerHTML = xhrSwatches.responseText;
                    } else {
                      console.error('Network response was not ok for swatches');
                    }
                  };
                  xhrSwatches.onerror = function () {
                    console.error("Error fetching color swatches using XMLHttpRequest");
                  };
                  xhrSwatches.send();
                  */
                });
              },500);


              ///////////////////////////////////////////

              
            } else {
                // body.classList.remove('wizzy-autocompleteOpened');
            }
        }
 
        searchBarWizz.addEventListener('click', toggleAutocompleteClass);

    window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
                desktop: 2e3,
                mobile: 2e3
            }
    
     return payload;
   });


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_INIT, function(payload){
     // console.log(payload,"Before init wizzy")
      payload.filters = {configs:{keepOpenedInMobileAfterApply:true, displayAsDrawer:false, keepOpenedInDesktopAfterApply:false}}
     let sortConfigs =  payload['search']['configs']['sorts']['configs'];
     let newElement = {
           field:"product_wizzy-best-selling_sortOrder:float",
           order:"asc",
           label:"Best Seller"
         }
     
      sortConfigs = [...sortConfigs.slice(0, 1), newElement, ...sortConfigs.slice(1)];
          payload['search']['configs']['sorts']['configs'] = sortConfigs

     window.wizzyConfig.search.configs.pagination.infiniteScrollOffset = {
            desktop: 2e3,
            mobile: 2e3
        };

    if(window.document.documentElement.clientWidth < 768){
       window.wizzyConfig.search.configs.general.minQueryLength = 1;
     }
     
     return payload;
   });


  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function(payload){
     // console.log("Wizzy VIEW_RENDERED")
     if(payload.data.api === "filter" || payload.data.api === "search"){
       const filterCount = document.querySelector(".wizzy-applied-filter-count");
       if(filterCount){
         const facetLength = document.querySelectorAll(".wizzy-facet-list-item.active");
         if(facetLength){
           if(facetLength.length > 0){
             filterCount.innerHTML = facetLength.length;
             var elementFiler = document.querySelector('.wizzy-applied-filter-count');
              if (elementFiler) {
                elementFiler.style.setProperty('display', 'flex', 'important');
              }
           }else {
             var elementFilerCount = document.querySelector('.wizzy-applied-filter-count');
              if (elementFilerCount) {
                elementFilerCount.style.setProperty('display', 'none', 'important');
              }
           }
         }
       }
     }
    if(window.ReloadSmartWishlist) window.ReloadSmartWishlist();
    
     return payload;
   });

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_SEARCH_EXECUTED, function(payload){
     // console.log("Wizzy BEFORE_SEARCH_EXECUTED", payload);
     
     // Select all input elements with the class .wizzy-search-input
      const inputs = document.querySelectorAll('.wizzy-search-input');
       if(inputs){
         inputs.forEach(input => {
            input.value = '';
          });
       }

     if(payload.sort){
       if(payload.sort.length > 0 && payload.sort[0].field === "relevance"){
         payload.sort.push({
           "field": "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
           "order":"desc"
         })
         payload.sort.push(
            {
                "field": "product_wizzy-best-selling_sortOrder:float",
                "order": "asc"
            }
         )
         // payload.sort = [
         //   {
         //     "field": "product_wizzy-best-selling_sortOrder:float",
         //     "order":"asc"
         //   },
         //   {
         //     "field": "relevance",
         //     "order":"asc"
         //   },
         //   {
         //     "field": "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
         //     "order":"desc"
         //   }
         // ]
       }
     }

     return payload;
   });

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_FILTERS_EXECUTED, function(payload){
     console.log("Wizzy BEFORE_FILTERS_EXECUTED", payload.filters);

     // if(payload.filters){
     //   if(payload.filters.sort){
     //     if(payload.filters.sort.length == 1 && payload.filters.sort[0].field === "sellingPrice"){
     //       payload.filters.inStock = [true,false];
     //     }
     //   }
     // }
     
     return payload;
   });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.VIEW_RENDERED, function (payload) {
    try {

      const cloneButtons = document.querySelectorAll(".cloneBtn");
      cloneButtons.forEach((button) => {

      if (button.getAttribute("data-listener-attached") !== "true") {
        
        button.setAttribute("data-listener-attached", "true");

        let hasClickedTwice = false;
        
          button.addEventListener("click", function () {
            const productHandle = button.getAttribute("product-handle");
            // if (!productHandle) return;
        
            const divId = "wizzy-product-" + button.getAttribute("id");
            const newUrl = `${window.location.origin}/products/${productHandle}?view=atbproductdata`;
        
            const xhr = new XMLHttpRequest();
            xhr.open("GET", newUrl, true);
        
            xhr.onload = function () {
              if (xhr.status === 200) {
                const newDiv = document.createElement("div");
                newDiv.innerHTML = xhr.responseText;
        
                const targetDiv = document.getElementById(divId);
                if (targetDiv) {
                  targetDiv.appendChild(newDiv);
                } else {
                  console.error(`Target div not found for product handle: ${productHandle}`);
                }
              } else {
                console.error(`Failed to fetch data for ${productHandle}. Status: ${xhr.status}`);
              }
            };
        
            xhr.onerror = function () {
              console.error(`Error occurred while fetching product data for ${productHandle}.`);
            };
        
            xhr.send();
  
            // var groupId = button.getAttribute('id');
            // console.log(groupId, "groupId");
            // setTimeout(function(){
            //   window.ATBModalOpen(event,groupId );
            // },1000);

            if (!hasClickedTwice) {
              hasClickedTwice = true;
              setTimeout(() => {
                button.click(); // One final click
              }, 700);
            }
            
          });
        }
      });


  
      // Swiper initialization (only initialize once)
      new Swiper('.autocomplete-top-products .collection-cardSwiper', {
        slidesPerView: 1,
        spaceBetween: 5,
        loop: false,
        autoplay:false,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })
  
      // Attach event listener via delegation
      document.body.addEventListener("click", function (event) {
        if (event.target.matches(".wizzy-quick-view-button")) {
          console.log("Quick view button clicked");
        }
      });


      const quickViewButtons = document.querySelectorAll(".wizzy-search-results .quick-view-btn");
      if(quickViewButtons){
        quickViewButtons.forEach((button) => {
          if (!button.dataset.listenerAttached) {
            button.addEventListener("click", async function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              e.stopPropagation();
    
              const uniqueId = button.getAttribute("product-group-id");
              const productHandle = button.getAttribute("product-handle");
              const modalId = `QuickAdd-${uniqueId}`;
    
              if (document.getElementById(modalId)) {
                console.log(`Modal for ${uniqueId} already exists.`);
              } else {
                const newUrl = `${window.location.origin}/products/${productHandle}?view=wizzy-quick-add-model`;
                try {
                  const response = await fetch(newUrl);
      
                  if (!response.ok) {
                    console.error(`Failed to fetch modal data for ${productHandle}. Status: ${response.status}`);
                    // return;
                  }
      
                  const html = await response.text();
                  const newDiv = document.createElement("div");
                  newDiv.innerHTML = html;
      
                  const modal = newDiv.querySelector('.quick-add-modal');
                  if (modal) {
                    document.body.appendChild(modal);
                  }
      
                }
                catch (error) {
                  console.error(`Error occurred while fetching the modal template for ${productHandle}.`, error);
                }
              }
              const fullCard = e.target.closest(".new_card_product_content");
              if (fullCard) {
                const quickAddBtn = fullCard.querySelector(".quick-add__submit");
                if (quickAddBtn) quickAddBtn.click();
              }
            });
            button.dataset.listenerAttached = "true";
          }
      });
      }   
  
      return payload;
    } catch (e) {
      console.error("Error in VIEW_RENDERED handler:", e);
      return payload;
    }
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.AFTER_PRODUCTS_TRANSFORMED, function(payload){  
  // console.log(payload,"AFTER_PRODUCTS_TRANSFORMED");
    try{
        payload.forEach((product)=>{
          product.attributes.forEach((attr)=>{
          if(attr.id === "product_handle"){
            product.handle = attr.values[0].value[0]
          }
          if(attr.id === "product_value_tags_front_end_labels"){
            product.hasBestSeller = attr?.values[0]?.value[0] ? true : false
          }
          if(attr.id === "product_style_number_custom"){
            product.styleNumber =  attr.values[0].value[0]
          }
          if (attr.id == "product_handle") {
            var productHandle = attr.values[0].value[0];
            product.productHandle = productHandle;
          }

          product.sizeswatch = product?.swatches?.filter((swatch)=>swatch.key === "sizes");
          if(product.sizeswatch && product.sizeswatch.length > 0){
              product.sizeswatch[0].values.forEach((value,index)=>{
                value.index = index;
                value.singleVarientGroupId = product.singleVarientGroupId;  
              })
            }
          })

          if(product.price){ 
            product.price = parseInt(product.price.replace(/,/g, ''),10).toLocaleString()
          }
          if(product.sellingPrice){
            product.sellingPrice = parseInt(product.sellingPrice.replace(/,/g, ''),10).toLocaleString()
          }   
      })

        payload.forEach((product) => {
          if (product.images && product.images.length > 3) {
            product.images = product.images.slice(0, 3); // Keep only the first 3 images
          }
        });

      // payload.forEach(product => {
      //   // Create the modal HTML string dynamically
      //     const modalHTML = `
      //     <quick-add-modal id="QuickAdd-${product.groupId}" class="quick-add-modal">
      //        <div role="dialog" aria-label="Choose options for Women's Endurance 10 Essential Panel Kneesuit Swimwear - Nordic Teal &amp; True Navy" aria-modal="true" class="quick-add-modal__content global-settings-popup" tabindex="-1">
      //           <button id="ModalClose-${product.groupId}" type="button" class="quick-add-modal__toggle" aria-label="Close">
      //              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" aria-hidden="true" focusable="false" class="icon icon-close" viewBox="0 0 24 24">
      //                 <line x1="18" y1="6" x2="6" y2="18"></line>
      //                 <line x1="6" y1="6" x2="18" y2="18"></line>
      //              </svg>
      //           </button>
      //           <div id="QuickAddInfo-${product.groupId}" class="quick-add-modal__content-info"></div>
      //        </div>
      //     </quick-add-modal>`;
      
      //     // Append the modal HTML to the end of the body
      //     document.body.insertAdjacentHTML('beforeend', modalHTML);
      // });

        
      }
      catch(e){
        console.log("Wizzy Event Error AFTER_PRODUCTS_TRANSFORMED",e)
      }
      finally{  
        return payload
      }
  });

    window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_RESULTS_RENDERED, function(payload){ 
      // console.log("Products VIEW IS RENDRED>>>>>>>>>>>>>>>")

      // Get the wrapper height if the element exists
      var wrapperHeightElement = document.querySelector('.wizzy-search-filters-left-wrapper');
      if (wrapperHeightElement) {
          var wrapperHeight = wrapperHeightElement.clientHeight;
          var newHeight = wrapperHeight + 105;
      
          // Check if the firstFacet element exists before modifying its style
          const firstFacet = document.querySelector('.wizzy-search-filters-left');
          if (firstFacet) {
              firstFacet.style.height = newHeight + 'px';
          }
      }
       
       updateCssVariable();
       updatePriceRange()
       updateSizes();
       updateColor();
      
       // Check if there are any .wizzy-filters-facet-block elements
      const wizzyFacet = document.querySelectorAll(".wizzy-filters-facet-block");
      if (wizzyFacet.length > 0) {
          wizzyFacet.forEach((element) => {
              const facetHeadTitle = element.querySelector(".facet-head-title");
              const activeItems = element.querySelectorAll(".active");
      
              if (facetHeadTitle && activeItems.length > 0 && !facetHeadTitle.classList.contains("Added")) {
                  facetHeadTitle.textContent += `(${activeItems.length})`;
                  facetHeadTitle.classList.add("Added");
              }
          });
      }

      
      // Get the noUi-value-large elements
      const noUiValueLarge = document.querySelectorAll(".noUi-value-large");
      
      if (noUiValueLarge.length > 1) {
          const noUiValueLarge2 = noUiValueLarge[1];
          const upperHandle = document.querySelector(".noUi-handle-upper");
          const upperTooltip = upperHandle ? upperHandle.querySelector(".noUi-tooltip") : null;
      
          if (noUiValueLarge2 && upperHandle && upperTooltip) {
              noUiValueLarge2.textContent = upperTooltip.textContent;
          }
      }
      
      if (noUiValueLarge.length > 0) {
          const noUiValueLarge1 = noUiValueLarge[0];
          const lowerHandle = document.querySelector(".noUi-handle-lower");
          const lowerTooltip = lowerHandle ? lowerHandle.querySelector(".noUi-tooltip") : null;
      
          if (noUiValueLarge1 && lowerHandle && lowerTooltip) {
              noUiValueLarge1.textContent = lowerTooltip.textContent;
          }
      }


      // if(window.ReloadSmartWishlist) window.ReloadSmartWishlist();
      
      filterCloseAndApplyButtons();

      let abc = new Swiper('.collection-cardSwiper', {
      slidesPerView: 1,
      spaceBetween: 5,
      loop: false,
      autoplay:false,
      breakpoints: {
        768: {
          slidesPerView: 1,
          spaceBetween: 10,
        },
      },
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
    })


    // Check if there are any .noUi-value.noUi-value-horizontal.noUi-value-large elements
    const elementsUI = document.querySelectorAll(".noUi-value.noUi-value-horizontal.noUi-value-large");
    
    elementsUI.forEach(function(element) {
        if (element && element.textContent) {
            const splitText = element.textContent.split(".");
            
            if (splitText[0]) {
                element.textContent = splitText[0];
            }
        }
    });

      return payload;
  });  

   window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_RENDER_RESULTS, function(payload){  
    console.log("BEFORE_RENDER_RESULTS ==> ",payload);
    try{
      // payload.response.payload.result = [];
        payload.response.payload.facets.forEach((facet)=>{
  
          if(facet.key === "sellingPrice") facet.order = 0;
          if(facet.key === "Category")  facet.order = 1;
          if(facet.key === "product_fabric_filter_custom")  facet.order = 2;
          if(facet.key === "sizes")  facet.order = 3;
          if(facet.key === "product_fit_type_filter_custom")  facet.order = 4;
          if(facet.key === "colors")  facet.order = 5;
          if(facet.key === "product_style_number_custom")  facet.order = 6;
          if(facet.key === "product_bra_style_filter_custom")  facet.order = 7;
  
        if (facet.key == "sizes" && facet.data.length > 0) {
              
            let sizes = facet.data;
            if(sizes){
              let updatedArray = sizeSorting(sizes);
                try{
                  facet.data = updatedArray.filter((item)=>item.key !== "Default Title");
                }
                catch(e){
                  console.log("Wizzy Event Error Facet BEFORE RENDER RESULTS", e)
                }
              }
          }
          
        if(facet.key === "colors"){
         let facetItem = facet.data;
          facetItem.forEach((item)=>{
              // console.log(item, "this is item") 
            var itemKey = item.key.toLowerCase();
              item.isSwatch = true;
              item.isURLSwatch = true;
              item.isVisualSwatch =true;
              item.swatchValue = item.key;
              itemKey = itemKey.trim();
              itemKey = itemKey.replace(/ /g,"-");
              item.data = {value: item.key, swatch: {type: 'visual', value:`https://www.speedo.in/cdn/shop/files/filter-value-image-${itemKey}.jpg?v=8844063560954989295`}}
            })
          }



          function sortFacetDataBySize(facetData) {
            const sizeOrder = [
              "24", "26", "28", "30", "32", "34", "36", "38", "40", "42", "44",
              "02Y","03Y","04Y", "05Y", "06Y", "07Y", "08Y", "09Y", "10Y", "12Y", "14Y",
              "1-2Y", "2-6", "2Y-6Y", "3-4Y", "4-5Y",
              "22 (3-4Y)", "24 (5-6Y)", "26 (7-8Y)", "28 (9-10Y)", "30 (11-12Y)", "32 (13-14Y)","34 (15-16Y)",
              "01-03", "02-06", "04-05","05-06","06-07","07-08","08-09","10-11","11-12","12-13",
              "Free Size", "S", "M", "L", "XL", "S-M"
            ];
          
            // Create a map for index lookup
            const sizeOrderMap = new Map(sizeOrder.map((val, idx) => [val, idx]));
          
            return facetData.sort((a, b) => {
              const aIndex = sizeOrderMap.has(a.key) ? sizeOrderMap.get(a.key) : Infinity;
              const bIndex = sizeOrderMap.has(b.key) ? sizeOrderMap.get(b.key) : Infinity;
              return aIndex - bIndex;
            });
          }


          if(facet.key === "sizes"){
            console.log(facet.data);
            const sortedData = sortFacetDataBySize(facet.data);
            console.log(sortedData);
            facet.data = sortedData;
          }
          
        });

      // if(payload.response && payload.api === "search"){
      //   if(payload.response.payload){
      //     if(payload.response.payload.filters.q){
      //       if(payload.response.payload.filters.q.toLowerCase() === "socks" || payload.response.payload.filters.q.toLowerCase() === "sock"){
      //         payload.error = true;
      //       }
      //     }
      //   }
      // }

      // Define an array of keywords that should trigger the error
      const invalidKeywords = ["socks", "sock", "mobile phones", "mobile"]; // Add more as needed
      
      if (payload.response && payload.api === "search") {
        if (payload.response.payload && payload.response.payload.filters.q) {
          const query = payload.response.payload.filters.q.toLowerCase();
          if (invalidKeywords.includes(query)) {
            payload.error = true;
          }
        }
      }

      if(payload.response) {
        if(payload.response.payload.facets && payload.response.payload.facets.length > 0){
          var allFacets = payload.response.payload.facets;
          // console.log(allFacets,"Wizz allFacets");
          allFacets.forEach(item => {
            if(item.key === "colors"){
              var allFacetsColors = item.data;
              // console.log(allFacetsColors,"wizz allFacetsColors");

              // var allFacetsColors = item.data;
              var uniqueColors = {};
              
              allFacetsColors.forEach(color => {
                if (uniqueColors[color.key]) {
                  uniqueColors[color.key].count += color.count;
                } else {
                  uniqueColors[color.key] = { ...color };
                }
              });
              
              var result = Object.values(uniqueColors);
              item.data = result;
              // console.log(result, "wizz uniqueColors");

            }
          })
        }
      }
      
      }
      catch(e){
            console.log("Wizzy Event Error BEFORE_RENDER_RESULTS",e)
      }
      finally{
            return payload
      }
        
    });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.PRODUCTS_CACHED_RESULTS_RENDERED, function(payload){

    console.log("PRODUCTS_CACHED_RESULTS_RENDERED->>>>>", payload);

    const cloneButtons = document.querySelectorAll(".cloneBtn");

        // console.log(cloneButtons, "wizz cloneButtons");
        
        cloneButtons.forEach((button) => {
          const productHandle = button.getAttribute("product-handle");
          // console.log(productHandle, "wizz productHandle");
          const WizzyCartDiv = document.querySelector(".innervariant");
        
          const domId = button.getAttribute("id") + "-inner";
          let divId = "wizzy-product-" + button.getAttribute("id");
        
          const productInfoDiv = button.closest(".new_card_product_info");
        
          const yyDiv = productInfoDiv.querySelector(".yy");
          const collectionColorSwatches = productInfoDiv.querySelector(".collection-color-swacthes");
        
          if (productHandle) {
            const newurl = `${window.location.origin}/products/${productHandle}?view=atbproductdata`;
        
            // Using XMLHttpRequest instead of fetch
            const xhr = new XMLHttpRequest();
            xhr.open("GET", newurl, true);
            
            xhr.onload = function () {
              if (xhr.status === 200) {
                console.log("ATB PRODUCT DATA...");
                
                var newDiv = document.createElement('div');
                newDiv.innerHTML = xhr.responseText;
                
                if (document.getElementById(`${divId}`)) {
                  document.getElementById(`${divId}`).appendChild(newDiv);
                }
              } else {
                console.error('Network response was not ok');
              }
            };
        
            xhr.onerror = function () {
              console.error("Wizzy Error Fetching ATB Product Data using XMLHttpRequest");
            };
        
            xhr.send();
          }
        
          /*
          const swatchURL = `${window.location.origin}/products/${productHandle}?view=wizzyColorSwatches`;
          const xhrSwatches = new XMLHttpRequest();
          xhrSwatches.open("GET", swatchURL, true);
          xhrSwatches.onload = function () {
            if (xhrSwatches.status === 200) {
              collectionColorSwatches.innerHTML = xhrSwatches.responseText;
            } else {
              console.error('Network response was not ok for swatches');
            }
          };
          xhrSwatches.onerror = function () {
            console.error("Error fetching color swatches using XMLHttpRequest");
          };
          xhrSwatches.send();
          */
        });


     new Swiper('.collection-cardSwiper', {
        slidesPerView: 1,
        spaceBetween: 5,
        loop: false,
        autoplay:false,
        breakpoints: {
          768: {
            slidesPerView: 1,
            spaceBetween: 10,
          },
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true,
        },
      })

    if(window.wizzyQuickViewAll){
      console.log("Enable event to the quick view button")
      window.wizzyQuickViewAll()
    }

    const quickViewButtons = document.querySelectorAll(".wizzy-search-results .quick-view-btn");
      if(quickViewButtons){
        quickViewButtons.forEach((button) => {
          if (!button.dataset.listenerAttached) {
            button.addEventListener("click", async function (e) {
              e.preventDefault();
              e.stopImmediatePropagation();
              e.stopPropagation();
    
              const uniqueId = button.getAttribute("product-group-id");
              const productHandle = button.getAttribute("product-handle");
              const modalId = `QuickAdd-${uniqueId}`;
    
              if (document.getElementById(modalId)) {
                console.log(`Modal for ${uniqueId} already exists.`);
              } else {
                const newUrl = `${window.location.origin}/products/${productHandle}?view=wizzy-quick-add-model`;
                try {
                  const response = await fetch(newUrl);
      
                  if (!response.ok) {
                    console.error(`Failed to fetch modal data for ${productHandle}. Status: ${response.status}`);
                    // return;
                  }
      
                  const html = await response.text();
                  const newDiv = document.createElement("div");
                  newDiv.innerHTML = html;
      
                  const modal = newDiv.querySelector('.quick-add-modal');
                  if (modal) {
                    document.body.appendChild(modal);
                  }
      
                }
                catch (error) {
                  console.error(`Error occurred while fetching the modal template for ${productHandle}.`, error);
                }
              }
              const fullCard = e.target.closest(".new_card_product_content");
              if (fullCard) {
                const quickAddBtn = fullCard.querySelector(".quick-add__submit");
                if (quickAddBtn) quickAddBtn.click();
              }
            });
            button.dataset.listenerAttached = "true";
          }
      });
    }

    return payload;
   });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_EXECUTED, function(payload) {
    
    const prohibitedWords = ["sock", "socks", "mobile phones", "mobile"];
    if (payload && prohibitedWords.includes(payload.q.toLowerCase())) {
      payload.q = "abcdefghijklmn";
    }

    payload.sort = [];
    payload.sort = [
          {
              "field": "relevance",
              "order": "asc"
          }
      ]

    if(payload.sort){
       if(payload.sort.length > 0 && payload.sort[0].field === "relevance"){
         payload.sort.push({
           "field": "product_value_tags_wizzy_hero_product_ruled_based_bt:float",
           "order":"desc"
         })
       }
     }

    payload.sort.push(
          {
              "field": "product_wizzy-best-selling_sortOrder:float",
              "order": "asc"
          }
    )

    if(window.document.documentElement.clientWidth < 768){
      payload.minQueryLength = 1;
     }
    
    return payload;
  });

  window.wizzyConfig.events.registerEvent(window.wizzyConfig.events.allowedEvents.BEFORE_AUTOCOMPLETE_RENDER, function(data) {
    // console.log(data, "<====BEFORE_AUTOCOMPLETE_RENDER");
    
    return data;
  });
  
}


/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////


// Check if the search icon exists before adding event listener
const searchIconSecond = document.querySelector(".header__icon--search span");
if (searchIconSecond) {
    searchIconSecond.addEventListener("click", function() {
        setTimeout(function() {
            const searchInput = document.querySelector(".search__input.field__input.wizzy-search-input");
            if (searchInput) {
                searchInput.click();
            }
        }, 1000);
    });
}

// Function to add event listeners to filter close and apply buttons
function filterCloseAndApplyButtons() {
    let buttons = document.querySelectorAll(".wizzy-mobile-facets__footer button");
    if (buttons.length > 0) {
        buttons.forEach(function(button) {
            button.addEventListener("click", function() {
                const filterBg = document.querySelector(".wizzy-filters-bg");
                if (filterBg) {
                    filterBg.click();
                }
            });
        });
    }
    window.isFirstAttachEventToWizzyFilter = false;
}

// Check if the device is mobile
function isMobileDevice() {
    return window.innerWidth <= 768;
}

// Observer to track style changes on body
function checkBodyStyle(mutationsList, observer) {
    for (const mutation of mutationsList) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'style') {
            const body = document.body;
            const bodyStyle = body.style;

            if (bodyStyle.overflow === 'hidden' && isMobileDevice()) {
                body.classList.add('wizzyAddToCartMobileOpen');
            } else {
                body.classList.remove('wizzyAddToCartMobileOpen');
            }
        }
    }
}

var configH = { attributes: true, attributeFilter: ['style'] };
var observer1 = new MutationObserver(checkBodyStyle);
observer1.observe(document.body, configH);

// Update CSS variable based on element width
function updateCssVariable() {
    const searchResultsElement = document.querySelector('.wizzy-search-results');
    if (searchResultsElement) {
        const elementWidth = searchResultsElement.clientWidth - 19;
        const cssVariableName = '--search-results-width';
        document.documentElement.style.setProperty(cssVariableName, `${elementWidth}px`);
    }
}

// Update on window resize
window.addEventListener('resize', updateCssVariable);

// Observer to track 'open' attribute on search details element
var observer2 = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutationRecord) {
        if (!mutationRecord.target.getAttribute("open")) {
            const element = document.getElementsByClassName("wizzy-autocomplete-wrapper")[0];
            if (element) {
                element.style.display = "none";
            }
        }
    });
});

var target2 = document.getElementsByClassName('header__search mobile-only')[0]?.querySelector("details");
if (target2) {
    observer2.observe(target2, { attributes: true, attributeFilter: ['open'] });
}

// Observer for changes in product-atb-modal
var observer3 = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutationRecord) {
        if (mutationRecord.target.classList.contains("active")) {
            const element = document.getElementsByClassName("wizzy-autocomplete-wrapper")[0];
            if (element) {
                element.style.display = "none";
            }
        }
    });
});

var target3 = document.getElementsByClassName('product-atb-modal')[0];
if (target3) {
    observer3.observe(target3, { attributes: true, attributeFilter: ['class'] });
}

// Update price range values
function updatePriceRange() {
    var element = document.querySelector('.wizzy-selected-facet-list-item[data-facetkey="sellingPrice"]');
    if (element) {
        var valueElement = element.querySelector('.facet-item-label-value');
        var value = valueElement.textContent.trim();
        value = value.replace('<', '₹0 -');
        let splitedValue = value.match(/₹([\d.]+)\s*-\s*₹([\d.]+)/);
        if (splitedValue) {
            let splitedValueMinValue = "₹" + parseFloat(splitedValue[1]).toFixed(0).toLocaleString();
            let splitedValueMaxValue = "₹" + parseFloat(splitedValue[2]).toFixed(0).toLocaleString();
            valueElement.textContent = splitedValueMinValue + ' - ' + splitedValueMaxValue;
        }
    }
}

// Update sizes in selected facet list
function updateSizes() {
    let elements = document.querySelectorAll('.wizzy-selected-facet-list-item[data-facetkey="sizes"]');
    elements.forEach((element) => {
        let valueElement = element.querySelector('.facet-item-label-value-id');
        if (valueElement) {
            let value = valueElement.textContent.trim();
            value = value.replace('sizes', 'Size');
            valueElement.textContent = value;
        }
    });
}

// Update color names in selected facet list
function updateColor() {
    let elements = document.querySelectorAll('.wizzy-selected-facet-list-item[data-facetkey="colors"]');
    elements.forEach((element) => {
        let valueElement = element.querySelector('.facet-item-label-value-id');
        if (valueElement) {
            let value = valueElement.textContent.trim();
            value = value.replace('colors', 'Color');
            valueElement.textContent = value;
        }
    });
}

// Add event listener for search icon click
const searchIcon = document.querySelector('.header__search.mobile-only');
if (searchIcon) {
    searchIcon.addEventListener('click', function(event) {
        var searchInput = document.getElementById('searchInput');
        if (searchInput) {
            searchInput.click();
        }

        var searchPage = document.getElementById('search_mini_form');
        if (searchPage) {
            searchPage.style.display = 'block';
        }

        if (searchInput) {
            searchInput.focus();
        }
    });
}

// Add focus/blur listeners for search bar to toggle autocomplete class
const searchBar = document.getElementById('Search-In-Modal');
if (searchBar) {
    function toggleAutocompleteClass() {
        const body = document.body;
        if (document.activeElement === searchBar) {
            body.classList.add('wizzy-autocompleteOpened');
        } else {
            body.classList.remove('wizzy-autocompleteOpened');
        }
    }

    searchBar.addEventListener('focus', toggleAutocompleteClass);
    searchBar.addEventListener('blur', toggleAutocompleteClass);
}

// Mutation observer for changes in header class
const targetNodeSecond = document.querySelector('.shopify-section.section-header');
if (targetNodeSecond) {
    const observerConfig = { attributes: true };
    const mutationCallback = function(mutationsList, observerNew) {
        mutationsList.forEach(mutation => {
            if (mutation.attributeName === 'class') {
                const headerHidden = targetNodeSecond.classList.contains('shopify-section-header-hidden');
                const bodyHasWizzyCustom = document.body.classList.contains('wizzy-custom');
                if (headerHidden && !bodyHasWizzyCustom) {
                    document.body.classList.add('wizzy-custom');
                } else if (!headerHidden && bodyHasWizzyCustom) {
                    document.body.classList.remove('wizzy-custom');
                }
            }
        });
    };

    const observerNew = new MutationObserver(mutationCallback);
    observerNew.observe(targetNodeSecond, observerConfig);
}


///////////////////////////  MUTATION OBSERVER   //////////////////////

// Select the target element
const wizzyAutocompleteTargetNode = document.querySelector('.wizzy-body-end-wrapper');

function updateWizzyAutocompleteBodyClass() {
  const autocompleteElement = wizzyAutocompleteTargetNode.querySelector('.wizzy-autocomplete-wrapper');
  if (
    autocompleteElement &&
    window.getComputedStyle(autocompleteElement).display === 'flex'
  ) {
    document.body.classList.add('wizzy-autocomplete-open');
  } else {
    document.body.classList.remove('wizzy-autocomplete-open');
  }
}

const wizzyAutocompleteObserverConfig = {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['style']
};

const wizzyAutocompleteCallback = function (mutationsList, wizzyObserver) {
  for (const mutation of mutationsList) {
    updateWizzyAutocompleteBodyClass();
    break; // One update is enough per mutation batch
  }
};

const wizzyAutocompleteObserver = new MutationObserver(wizzyAutocompleteCallback);
if (wizzyAutocompleteTargetNode) {
  wizzyAutocompleteObserver.observe(wizzyAutocompleteTargetNode, wizzyAutocompleteObserverConfig);
  updateWizzyAutocompleteBodyClass();
}


///////////////////////////////////////////////////////////////////////////////

const attachedIcons = new WeakSet();
function attachClickHandlersToAutocompleteIcons() {
  const wrapper = document.querySelector('.wizzy-body-end-wrapper .wizzy-autocomplete-wrapper');
  if (!wrapper) return;

  const allClickableSelectors = [
    '.wizzy-autocomplete-suggestions .autocomplete-item .wizzy-recent-search-clear-icon',
    '.wizzy-autocomplete-suggestions .wizzy-recent-search-clear-all'
  ];

  allClickableSelectors.forEach((selector) => {
    const elements = wrapper.querySelectorAll(selector);
    elements.forEach((el) => {
      if (!attachedIcons.has(el)) {
        attachedIcons.add(el);
        el.addEventListener('click', function () {
          setTimeout(function () {
            if (typeof window.ReloadSmartWishlist === 'function') {
              window.ReloadSmartWishlist();
            }
          }, 300);
          
          setTimeout(function(){
                 new Swiper('.autocomplete-top-products .collection-cardSwiper', {
                  slidesPerView: 1,
                  spaceBetween: 5,
                  loop: false,
                  autoplay:false,
                  breakpoints: {
                    768: {
                      slidesPerView: 1,
                      spaceBetween: 10,
                    },
                  },
                  pagination: {
                    el: '.swiper-pagination',
                    clickable: true,
                  },
                });
                if(window.ReloadSmartWishlist) window.ReloadSmartWishlist();
              },500);
              
        });
      }
    });
  });
}


const wizzyBodyWrapper = document.querySelector('.wizzy-body-end-wrapper');
if (wizzyBodyWrapper) {
  const observer = new MutationObserver((mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'childList' || mutation.type === 'attributes') {
        attachClickHandlersToAutocompleteIcons();
        break; 
      }
    }
  });

  observer.observe(wizzyBodyWrapper, {
    childList: true,
    subtree: true,
    attributes: true,
  });

  attachClickHandlersToAutocompleteIcons();
}
